/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse,
  GetTournamentsTournamentidReplayMetricsGameScoresPathParams,
  GetTournamentsTournamentidReplayMetricsGameScores404,
} from "../types/GetTournamentsTournamentidReplayMetricsGameScores.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsTournamentidReplayMetricsGameScoresQueryKey = (
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsGameScoresPathParams["tournamentId"]
    | undefined,
) =>
  [
    {
      url: "/tournaments/:tournamentId/replay-metrics/game-scores",
      params: { tournamentId: tournamentId },
    },
  ] as const;

export type GetTournamentsTournamentidReplayMetricsGameScoresQueryKey =
  ReturnType<typeof getTournamentsTournamentidReplayMetricsGameScoresQueryKey>;

/**
 * @summary KAN-1166: лёгкая версия `/replay-metrics/games` — строка «игрок × игра» только
 * с полями столбика профиля (балл, чемпион, исход, флаги). Полный ответ старой ручки
 * весил ~1,7 МБ на турнир и уходил при открытии страницы итогов.
 * Пустой список — реплеев нет либо ни одна игра не набрала группы сравнения.
 * {@link /tournaments/:tournamentId/replay-metrics/game-scores}
 */
export async function getTournamentsTournamentidReplayMetricsGameScores(
  tournamentId: GetTournamentsTournamentidReplayMetricsGameScoresPathParams["tournamentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsGameScores404>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${tournamentId}/replay-metrics/game-scores`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsTournamentidReplayMetricsGameScoresQueryOptions(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsGameScoresPathParams["tournamentId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getTournamentsTournamentidReplayMetricsGameScoresQueryKey(tournamentId);
  return queryOptions<
    ResponseConfig<GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse>,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsGameScores404>,
    ResponseConfig<GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse>,
    typeof queryKey
  >({
    enabled: !!tournamentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsTournamentidReplayMetricsGameScores(tournamentId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-1166: лёгкая версия `/replay-metrics/games` — строка «игрок × игра» только
 * с полями столбика профиля (балл, чемпион, исход, флаги). Полный ответ старой ручки
 * весил ~1,7 МБ на турнир и уходил при открытии страницы итогов.
 * Пустой список — реплеев нет либо ни одна игра не набрала группы сравнения.
 * {@link /tournaments/:tournamentId/replay-metrics/game-scores}
 */
export function useGetTournamentsTournamentidReplayMetricsGameScores<
  TData =
    ResponseConfig<GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse>,
  TQueryKey extends QueryKey =
    GetTournamentsTournamentidReplayMetricsGameScoresQueryKey,
>(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsGameScoresPathParams["tournamentId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsTournamentidReplayMetricsGameScoresQueryResponse>,
        ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsGameScores404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTournamentsTournamentidReplayMetricsGameScoresQueryKey(tournamentId);

  const query = useQuery(
    {
      ...getTournamentsTournamentidReplayMetricsGameScoresQueryOptions(
        tournamentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsGameScores404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
